const MenuClose = (props) => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="0.0400391"
        y="20.3389"
        width="28"
        height="3"
        transform="rotate(-45 0.0400391 20.3389)"
        fill="currentColor"
      />
      <rect
        x="2.16113"
        y="0.540039"
        width="28"
        height="3"
        transform="rotate(45 2.16113 0.540039)"
        fill="currentColor"
      />
    </svg>
  );
};

export default MenuClose;
